import { render, staticRenderFns } from "./InocuidadAlimentaria.vue?vue&type=template&id=efa8c4be&"
import script from "./InocuidadAlimentaria.vue?vue&type=script&lang=js&"
export * from "./InocuidadAlimentaria.vue?vue&type=script&lang=js&"
import style0 from "./InocuidadAlimentaria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports